import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigInfo } from '@interfaces/config-info.interface';
import { NamedValue } from '@interfaces/namedvalue.interface';
import { firstValueFrom } from 'rxjs';

const RETRIEVE_CONFIG_URL = '/thesaurus-gateway/retrieveconfig';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private configInfo: NamedValue[] | null = null;
  private configLoaded = false;

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    return firstValueFrom(
      this.http.get<ConfigInfo>(RETRIEVE_CONFIG_URL, {
        headers: new HttpHeaders({
          'Accept': 'application/json'
        })
      })
    )
      .then((response) => {
        this.configInfo = this.parseConfigResponse(JSON.stringify(response));
        this.configLoaded = true;
        //console.log('Application config loaded successfully:', this.configInfo);
      })
      .catch((error) => {
        console.error('Error retrieving application config from /thesaurus-gateway/retrieveconfig.', error);
        this.configLoaded = true;
      });
  }

  getConfigInfo(): NamedValue[] | null {
    return this.configInfo;
  }

  isConfigLoaded(): boolean {
    return this.configLoaded;
  }

  private parseConfigResponse(response: any): NamedValue[] | null {
    const jsonObj = JSON.parse(response);

    var namedValueList: NamedValue[] = Object.entries(jsonObj).map(([key, value]) => ({
      name: key,
      value: String(value)
    }));
    
    return namedValueList;
  }

  private getConfigValue(configName: string): string | number | null {
    if (!this.configInfo) {
      console.warn('Config info is not loaded yet.');
      return null;
    }
    const configValue = this.configInfo.find((nv) => nv.name === configName);
    return configValue ? configValue.value : null;
  }

  isThesaurusRefreshEnabled(): boolean {
    const value = this.getConfigValue('thesaurusrefreshenabled');
    return value === 'true';
  }

  isThesaurusRefreshDescriptionsEnabled(): boolean {
    const value = this.getConfigValue('thesaurusrefreshdescriptionsenabled');
    return value === 'true';
  }
}